module.exports = __webpack_public_path__ + "f7f03545f3cfe8a63e5e0ab964e4fe41.pdf";